import { createActionGroup, props } from '@ngrx/store';
import { SetTicketHolderSendingOptionFormFields } from '../models/order-summary-store.model';

export const OrderSummaryActions = createActionGroup({
  source: 'Order summary',
  events: {
    'Set ticket holder sending option form fields': props<SetTicketHolderSendingOptionFormFields>()
  }
});
